import React, { useEffect, useState } from 'react';
import { api } from './api';

const card = { background: 'white', borderRadius: 14, padding: 22, boxShadow: '0 8px 22px rgba(15,23,42,.08)', border: '1px solid #e2e8f0' };
const input = { width: '100%', padding: 11, border: '1px solid #cbd5e1', borderRadius: 8, boxSizing: 'border-box' };
const btn = { padding: '12px 16px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 800 };

export default function MercadoPago() {
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ access_token: '', public_key: '', cuenta_email: '', collector_id: '', external_pos_id: '', activo: true, modo: 'produccion' });
  const [ordenes, setOrdenes] = useState([]);
  const [resumen, setResumen] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  const cargar = async () => {
    setError('');
    try {
      const cfg = await api.get('/api/mercado-pago/configuracion');
      setData(cfg);
      setForm((prev) => ({ ...prev, ...cfg.cuenta, access_token: '', public_key: cfg.cuenta.public_key || '', activo: cfg.cuenta.activo }));
      const o = await api.get('/api/mercado-pago/ordenes');
      setOrdenes(Array.isArray(o) ? o : []);
      const r = await api.get('/api/mercado-pago/cierre/resumen');
      setResumen(r.resumen || []);
    } catch (e) { setError(e.mensaje || e.message || 'No se pudo cargar Mercado Pago.'); }
  };

  useEffect(() => { cargar(); }, []);

  const guardar = async () => {
    setCargando(true); setMensaje(''); setError('');
    try {
      const payload = { ...form };
      if (!payload.access_token) delete payload.access_token;
      await api.put('/api/mercado-pago/configuracion', payload);
      setMensaje('Configuración de Mercado Pago guardada para esta empresa.');
      await cargar();
    } catch (e) { setError(e.mensaje || e.message || 'No se pudo guardar.'); }
    finally { setCargando(false); }
  };

  const desconectar = async () => {
    if (!window.confirm('¿Desconectar Mercado Pago de esta empresa?')) return;
    setCargando(true);
    try { await api.post('/api/mercado-pago/desconectar', {}); await cargar(); }
    catch (e) { setError(e.mensaje || e.message || 'No se pudo desconectar.'); }
    finally { setCargando(false); }
  };

  const probarOrden = async () => {
    const total = Number(prompt('Importe de prueba para generar QR / checkout', '100'));
    if (!Number.isFinite(total) || total <= 0) return;
    setCargando(true); setError(''); setMensaje('');
    try {
      const r = await api.post('/api/mercado-pago/ordenes', { total, descripcion: 'Prueba Mercado Pago', idempotency_key: `test-${Date.now()}` });
      setMensaje(`Orden creada: ${r.orden?.referencia || ''}`);
      if (r.orden?.checkout_url) window.open(r.orden.checkout_url, '_blank', 'noopener,noreferrer');
      await cargar();
    } catch (e) { setError(e.mensaje || e.message || 'No se pudo crear la orden.'); }
    finally { setCargando(false); }
  };

  const conectado = data?.cuenta?.conectado;

  return <div style={{ padding: 28 }}>
    <h1 style={{ marginTop: 0 }}>💙 Mercado Pago automático</h1>
    <p style={{ color: '#64748b', fontSize: 17 }}>Conexión independiente por empresa. Casa Alessio y MKiosco24 usan credenciales, QR, conciliación y cierres separados.</p>

    {error && <div style={{ ...card, borderColor: '#fecaca', background: '#fef2f2', color: '#991b1b', marginBottom: 18 }}>{error}</div>}
    {mensaje && <div style={{ ...card, borderColor: '#bbf7d0', background: '#f0fdf4', color: '#166534', marginBottom: 18 }}>{mensaje}</div>}

    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(320px, 1.1fr) minmax(300px,.9fr)', gap: 18 }}>
      <section style={card}>
        <h2 style={{ marginTop: 0 }}>Configuración de la empresa activa</h2>
        <div style={{ marginBottom: 12, padding: 12, borderRadius: 10, background: conectado ? '#ecfdf5' : '#fff7ed', color: conectado ? '#047857' : '#c2410c', fontWeight: 800 }}>
          {conectado ? '✅ Mercado Pago conectado' : '⚠️ Mercado Pago pendiente de conexión'}
        </div>
        <label>Cuenta / email<input style={input} value={form.cuenta_email || ''} onChange={(e) => setForm({ ...form, cuenta_email: e.target.value })} placeholder="cuenta@mercadopago.com" /></label>
        <label style={{ display: 'block', marginTop: 10 }}>Access token privado<input type="password" style={input} value={form.access_token || ''} onChange={(e) => setForm({ ...form, access_token: e.target.value })} placeholder={data?.cuenta?.access_token_mask || 'APP_USR-...'} /></label>
        <small style={{ color: '#64748b' }}>Se guarda en el servidor y nunca se muestra completo. No pegues este token en chats.</small>
        <label style={{ display: 'block', marginTop: 10 }}>Public key<input style={input} value={form.public_key || ''} onChange={(e) => setForm({ ...form, public_key: e.target.value })} placeholder="APP_USR-..." /></label>
        <label style={{ display: 'block', marginTop: 10 }}>Collector ID<input style={input} value={form.collector_id || ''} onChange={(e) => setForm({ ...form, collector_id: e.target.value })} /></label>
        <label style={{ display: 'block', marginTop: 10 }}>External POS ID / caja<input style={input} value={form.external_pos_id || ''} onChange={(e) => setForm({ ...form, external_pos_id: e.target.value })} placeholder="casa-alessio-caja-1" /></label>
        <label style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12 }}><input type="checkbox" checked={!!form.activo} onChange={(e) => setForm({ ...form, activo: e.target.checked })} /> Activo para cobrar ventas</label>
        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button style={{ ...btn, background: '#009ee3', color: 'white' }} disabled={cargando} onClick={guardar}>Guardar conexión</button>
          <button style={{ ...btn, background: '#e2e8f0' }} disabled={cargando || !conectado} onClick={desconectar}>Desconectar</button>
          <button style={{ ...btn, background: '#22c55e', color: 'white' }} disabled={cargando || !conectado} onClick={probarOrden}>Probar QR</button>
        </div>
      </section>

      <section style={card}>
        <h2 style={{ marginTop: 0 }}>Webhook</h2>
        <p style={{ color: '#64748b' }}>Configurá esta URL en Mercado Pago para recibir confirmaciones automáticas:</p>
        <pre style={{ whiteSpace: 'pre-wrap', background: '#f8fafc', padding: 12, borderRadius: 10, border: '1px solid #e2e8f0' }}>{data?.webhook_url || 'Cargando...'}</pre>
        <h3>Resumen de hoy</h3>
        {resumen.length ? resumen.map((r) => <div key={r.estado} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e2e8f0', padding: '8px 0' }}><b>{r.estado}</b><span>{r.cantidad} · ${Number(r.total).toFixed(2)}</span></div>) : <p style={{ color: '#94a3b8' }}>Sin movimientos de Mercado Pago hoy.</p>}
      </section>
    </div>

    <section style={{ ...card, marginTop: 18 }}>
      <h2 style={{ marginTop: 0 }}>Últimas órdenes</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f1f5f9' }}><th style={{ textAlign: 'left', padding: 10 }}>Referencia</th><th>Estado</th><th>Total</th><th>Creada</th><th>Link</th></tr></thead>
        <tbody>{ordenes.map((o) => <tr key={o.id} style={{ borderBottom: '1px solid #e2e8f0' }}><td style={{ padding: 10 }}>{o.referencia}</td><td>{o.estado}</td><td>${Number(o.total).toFixed(2)}</td><td>{new Date(o.creado_en).toLocaleString('es-AR')}</td><td>{o.checkout_url ? <a href={o.checkout_url} target="_blank" rel="noreferrer">Abrir</a> : '-'}</td></tr>)}</tbody>
      </table>
    </section>
  </div>;
}
